import _ from 'lodash'
import * as actionTypes from './actionTypes'
import { getAxios } from '../../lib/projectAxios'
import uuid from 'uuid/v4'

const axios = getAxios()

export const processAIAction = async (jobs, nextStep, dispatch) => {
  if (!jobs) {
    return false
  }

  let requestData = {}
  jobs = jobs.toJS()
  _.each(jobs, (row, key) => {
    if (row.text) {
      requestData[key] = {
        text: row.text,
      }
    }
  })

  const recursiveProcessGet = async (attemp) => {
    if (attemp >= 3) {
      return {
        status: 200,
        data: {
          status: false,
        },
      }
    }
    try {
      let result = await axios.post('/webprojects/ai', requestData)
      return result
    } catch (err) {
      console.log('err >>> ', err)
      dispatch({
        type: actionTypes.NOTIFY_ERROR,
        payload: {
          key: uuid(),
          message: `You are offline, trying again in 2 seconds...`,
        },
      })
      await new Promise((resolve) => {
        setTimeout(resolve, 2 * 1000)
      })

      return recursiveProcessGet(attemp + 1)
    }
  }

  let { status, data } = await recursiveProcessGet(0)

  dispatch({
    type: actionTypes.PROCESS_RESULT_AI,
    payload: {
      params: jobs,
      data: data,
      nextStep,
    },
  })
}
